import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";
import SessionalPositionsAction from "@common/redux/actions/SessionalPositionsAction";
import { makeLabels } from "@common/components/helpers/machines";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const useSessionsUtils = () => {
  const history = useHistory();
  const positions = useSelector((state) =>
    SessionalPositionsAction.getStatePath(state),
  );

  const labels = makeLabels(positions, false, false);

  const onPositionClick = (activeRow) => {
    SessionalPositionsAction.dispatch({ activeRow });
  };

  const onDetailClick = (row) => {
    const sessionId = row.sessionId;
    history.push(`/sessions/view/?id=${sessionId}`);
  };

  const toggleFilter = (key) => {
    SessionalPositionsAction.dispatch({ [key]: !positions[key] });
  };

  const onPageChange = (e, { activePage }) => {
    SessionalDetailsAction.dispatch({ pageNumber: activePage });
  };

  const onBack = () => history.push("/dashboard");

  return {
    labels,
    onPositionClick,
    onDetailClick,
    toggleFilter,
    onPageChange,
    onBack,
  };
};

export default useSessionsUtils;
